import React, { useEffect, useRef, useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View, Modal, TextInput, ScrollView, Image, Dimensions, Animated } from 'react-native';
import Storage from '@aws-amplify/storage';
import IconImages from "./IconImages";
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { AppUser, DayDiagnoseComment, DayDiagnosis, Photo, PhotoComment } from "../../models";
import { DataStore, Predicates, SortDirection } from "aws-amplify";
import { getCurrentUser, S3Image, toLocalString, getCurrentDateTime } from "./CmnUtil";
import ImageZoom from "react-native-image-pan-zoom";

// 保存確認ダイアログ表示
export const SaveDialog = (props: any) => {
  const {
    cancelButtonName,
    saveButtonName,
    canceAction,
    saveAction,
    message,
    visible,
  } = props;

  const onClickCancelButton = () => canceAction();

  const onClickSaveButton = () => saveAction();

  const dialogStyle = StyleSheet.create({
    dialogContainer: {
      position: "absolute",
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(150,150,150,0.6)",
    },
    dialogBox: {
      width: 270,
      height: 140,
      backgroundColor: "#eeeeee",
      borderRadius: 10
    },
    dialogTopBox: {
      flex: 0.6,
      justifyContent: "center",
      alignItems: "center",
      borderBottomColor: "#ccc",
      borderBottomWidth: 1,
      borderStyle: "solid"
    },
    dialogText: {
      fontSize: 18,
    },
    dialogBottomBox: {
      flex: 0.4,
      flexDirection: "row",

    },
    dialogButton: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    dialogNegative: {
      fontSize: 18,
      color: "#808080",
    },
    dialogPositive: {
      fontSize: 18,
      color: "#0000ff",
    },
  });

  return (
    <Modal
      transparent={true}
      visible={visible}
    >
      <View style={dialogStyle.dialogContainer}>
        <View style={dialogStyle.dialogBox}>
          <View style={dialogStyle.dialogTopBox}>
            <Text style={dialogStyle.dialogText}>{message}</Text>
          </View>
          <View style={dialogStyle.dialogBottomBox}>
            <TouchableOpacity
              style={[dialogStyle.dialogButton, { borderRightWidth: 1, borderRightColor: "#ddd", borderStyle: "solid" }]}
              onPress={() => onClickCancelButton()}
            >
              <Text style={dialogStyle.dialogNegative}>{cancelButtonName}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[dialogStyle.dialogButton, { borderLeftWidth: 1, borderLeftColor: "#ddd", borderStyle: "solid" }]}
              onPress={() => onClickSaveButton()}
            >
              <Text style={dialogStyle.dialogPositive}>{saveButtonName}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

// 保存確認ダイアログ表示
export const ConfirmDialog = (props: any) => {
  const {
    confirmButtonName,
    confirmAction,
    message,
    visible,
  } = props;

  const onClickConfirmButton = () => confirmAction();

  const dialogStyle = StyleSheet.create({
    dialogContainer: {
      position: "absolute",
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(150,150,150,0.6)",
    },
    dialogBox: {
      width: 270,
      height: 140,
      backgroundColor: "#eeeeee",
      borderRadius: 10
    },
    dialogTopBox: {
      flex: 0.6,
      justifyContent: "center",
      alignItems: "center",
      borderBottomColor: "#ccc",
      borderBottomWidth: 1,
      borderStyle: "solid"
    },
    dialogText: {
      fontSize: 18,
    },
    dialogBottomBox: {
      flex: 0.4,
      flexDirection: "row",

    },
    dialogButton: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    dialogNegative: {
      fontSize: 18,
      color: "#808080",
    },
    dialogPositive: {
      fontSize: 18,
      color: "#0000ff",
    },
  });

  return (
    <Modal
      transparent={true}
      visible={visible}
    >
      <View style={dialogStyle.dialogContainer}>
        <View style={dialogStyle.dialogBox}>
          <View style={dialogStyle.dialogTopBox}>
            <Text style={dialogStyle.dialogText}>{message}</Text>
          </View>
          <View style={dialogStyle.dialogBottomBox}>
            <TouchableOpacity
              style={[dialogStyle.dialogButton, { borderLeftWidth: 1, borderLeftColor: "#ddd", borderStyle: "solid" }]}
              onPress={() => onClickConfirmButton()}
            >
              <Text style={dialogStyle.dialogPositive}>{confirmButtonName}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

// コメントダイアログ用型定義
export type CommentType = "photo" | "dayDiagnosis";
interface CommentData {
  id: string,
  icon: string,
  name: string,
  comment: string,
  date: string,
  time: string,
  isDeletable: boolean,
};
/**
 * コメントダイアログ
 * @param props :{onClickColse: () => void, id: string, type: string, visible: boolean }
 * @returns 
 */
export const CommentDialog = ({
  onClickClose,
  id,
  type,
  visible,
}: {
  onClickClose: () => void,
  id: string,
  type: CommentType,
  visible: boolean,
}) => {

  // 送信コメント格納State
  const [inputValue, setInputValue] = useState<string>("");

  // idとtypeから決定されるPhoto
  const [photoModel, setPhotoModel] = useState<Photo>();

  // idとtypeから決定されるDayDiagnosis
  const [dayDiagnosisModel, setDayDiagnosisModel] = useState<DayDiagnosis>();

  // スクロールビュー
  const scrollView = useRef<ScrollView>(null);

  // コメント
  const [commentData, setCommentData] = useState<CommentData[]>([]);

  // コメント取得済み
  const [fethced, setFethced] = useState<boolean>(false);

  // 送信ボタン押下
  const sendMessage = () => {
    if (inputValue == "") { return; };
    saveComent();
    setInputValue("");
  };

  // 送信ボタン押下
  const deleteMessage = async (commentId: any) => {
    const result = window.confirm("コメントを削除しますか？")
    if (!result) {
      return
    }
    try {
      if (type == "dayDiagnosis" && dayDiagnosisModel != undefined) {
        await DataStore.delete(DayDiagnoseComment, c => c.id("eq", commentId));
      } else if (type == "photo" && photoModel != undefined) {
        await DataStore.delete(PhotoComment, c => c.id("eq", commentId));
      };
    } catch (e) {
      console.error(e)
    }
  };

  // 「☓」アイコン押下
  const close = () => {
    onClickClose();
    setInputValue("");
    setCommentData([]);
    setFethced(false);
  };

  /**
   * コメント取得
   */
  const fetchComment = async () => {
    // idが空もしくは非表示状態ならリターン
    if (id === "" || !visible) { return; };

    let comments: DayDiagnoseComment[] | PhotoComment[] = [];

    // typeにより取得先を変更
    if (type === "dayDiagnosis") {
      comments = (await DataStore.query(DayDiagnoseComment, Predicates.ALL, {
        sort: c => c.createdAt(SortDirection.ASCENDING),
      })).filter(c => c[type].id == id);
    } else if (type === "photo") {
      comments = (await DataStore.query(PhotoComment, Predicates.ALL, {
        sort: c => c.createdAt(SortDirection.ASCENDING),
      })).filter(c => c[type].id == id);
    };

    // commentDataにセットするデータを揃える
    const appUser = await getCurrentUser();
    const addData: CommentData[] = await Promise.all(comments.map(async (comment) => {
      // コメント一枚分
      let add: CommentData = { id: comment.id, icon: "", name: "", comment: "", date: "", time: "", isDeletable: comment.authorID === appUser?.id };

      // コメントしたユーザー
      const user = await DataStore.query(AppUser, c => c.id("eq", comment.authorID));

      // コメントしたユーザーの情報があれば、画像と名前を取得
      if (user.length != 0) {
        if (user[0].icon != undefined) {
          add.icon = user[0].icon;
        };

        add.name = user[0].username;
      };

      // コメント内容
      add.comment = comment.text;

      // コメントした日付
      if (comment.createdAt != undefined) {
        const dateTime = toLocalString(comment.createdAt);
        add.date = dateTime.slice(0, 10);
        add.time = dateTime.slice(11, 16);
      };

      return add;
    }));

    setCommentData(addData);
  };

  /**
   * 送信コメント&送信者データ取得
   * @param tmpValue 
   * @returns 
   */
  const getSentCommentWithAppUserData = async (tmpValue: any): Promise<CommentData> => {
    let content: CommentData = { id: "", icon: "", name: "", comment: "", date: "", time: "", isDeletable: false };
    const senderUser = (await DataStore.query(AppUser, c => c.id("eq", tmpValue.element.authorID)))[0];
    if (typeof senderUser !== "undefined") {
      if (senderUser.icon != undefined) {
        content.icon = senderUser.icon;
      };
      content.name = senderUser.username;
    };
    content.id = tmpValue.element.id;
    content.comment = tmpValue.element.text;
    const dateTime = getCurrentDateTime();
    content.date = dateTime.slice(0, 10);
    content.time = dateTime.slice(11, 16);
    const currentUser = await getCurrentUser()
    if (currentUser) {
      content.isDeletable = currentUser.id === senderUser.id
    }
    return content;
  };

  /**
   * コメント保存処理
   */
  const saveComent = async () => {
    const appUser = await getCurrentUser();
    const authorID: string = typeof appUser !== "undefined" ?
      appUser.id
      :
      "";

    if (authorID == "") { return; };

    if (type == "dayDiagnosis" && dayDiagnosisModel != undefined) {
      await DataStore.save(new DayDiagnoseComment({
        dayDiagnosis: dayDiagnosisModel,
        authorID: authorID,
        text: inputValue,
      }));
    } else if (type == "photo" && photoModel != undefined) {
      await DataStore.save(new PhotoComment({
        photo: photoModel,
        authorID: authorID,
        text: inputValue,
      }));
    };
  };

  // 購読
  useEffect(() => {
    const dayDiagnosisSubscribe = DataStore.observe(DayDiagnoseComment).subscribe(
      async value => {
        const tmpValue: any = value;
        if (tmpValue.opType == "INSERT" && tmpValue.element.dayDiagnosisID == id) {
          const content = await getSentCommentWithAppUserData(tmpValue);
          setCommentData([...commentData, content]);
        };
        if (tmpValue.opType == "DELETE" && tmpValue.element.dayDiagnosis.id == id) {
          setCommentData(commentData.filter(d => d.id !== tmpValue.element.id));
        };
      }
    );
    const photoSubscribe = DataStore.observe(PhotoComment).subscribe(
      async value => {
        const tmpValue: any = value;
        if (tmpValue.opType == "INSERT" && tmpValue.element.photoID == id) {
          const content = await getSentCommentWithAppUserData(tmpValue);
          setCommentData([...commentData, content]);
        };
        if (tmpValue.opType == "DELETE" && tmpValue.element.photo.id == id) {
          setCommentData(commentData.filter(d => d.id !== tmpValue.element.id));
        };
      }
    );

    // 最下部にスクロール
    scrollView?.current?.scrollToEnd({ animated: false });

    return () => {
      dayDiagnosisSubscribe.unsubscribe();
      photoSubscribe.unsubscribe();
    };

  }, [commentData]);

  // typeとidによりモデルをセット
  useEffect(() => {
    (async () => {
      if (type == "dayDiagnosis") {
        const dayDiagnosis = await DataStore.query(DayDiagnosis, c => c.id("eq", id));
        if (dayDiagnosis.length != 0) {
          setDayDiagnosisModel(dayDiagnosis[0]);
        };
      } else if (type == "photo") {
        const photo = await DataStore.query(Photo, c => c.id("eq", id));
        if (photo.length != 0) {
          setPhotoModel(photo[0]);
        };
      };
    })();
  }, [type, id]);

  // コメントを取得 
  useEffect(() => {
    if (!fethced && (photoModel || dayDiagnosisModel)) {
      fetchComment();
      if (visible || !(photoModel || dayDiagnosisModel)) {
        setFethced(true);
      };
    };
  }), [photoModel, dayDiagnosisModel, fethced];

  return (
    <Modal
      transparent={true}
      visible={visible}
    >
      <View style={{ backgroundColor: "rgba(100,100,100,0.5)", justifyContent: "center", alignItems: "center", flex: 1, }}>
        <View style={{ width: "100%", height: 400, padding: 10, backgroundColor: "#ffffff", }}>
          <View style={{ borderBottomColor: "#70AD47", borderBottomWidth: 2, borderStyle: "solid", paddingVertical: 10, position: "relative" }}>{/* ヘッダー */}
            <Text style={{ fontSize: 20, fontWeight: "bold", textAlign: "center", }}>コメント</Text>
            <TouchableOpacity onPress={() => close()} style={{ position: "absolute", right: 0, top: -5 }}>
              <MaterialCommunityIcons style={{ width: 28, height: 28, }} name={"window-close"} size={28} />
            </TouchableOpacity>
          </View>
          <ScrollView ref={scrollView} style={{ height: 350, paddingVertical: 20, }}>{/* コメントコンテイナー */}
            {commentData.map((data, key) => {
              return <View key={key} style={{ flexDirection: "row", width: "100%", marginBottom: 10, }}>
                <S3Image resizeMode="contain" imageKey={data.icon} style={{ width: 50, height: 50, marginHorizontal: 15, borderRadius: 25, backgroundColor: "#808080", }} defaultSource={IconImages.icUser} />
                <View style={{ flex: 1, marginHorizontal: 15, }}>
                  <Text style={{ fontWeight: "bold", fontSize: 16, }}>{data.name}</Text>
                  <Text style={{ fontSize: 16, }}>{data.comment}</Text>
                  <View style={{ flexDirection: "row", }}>
                    <Text style={{ fontSize: 12, marginRight: 10, }}>{data.date}</Text>
                    <Text style={{ fontSize: 12, marginRight: 10, }}>{data.time}</Text>
                    {data.isDeletable
                      ? <Text style={{ fontSize: 12, }} onPress={() => deleteMessage(data.id)} >🗑️ 削除する</Text>
                      : <Text></Text>
                    }
                  </View>
                </View>
              </View>;
            })}
          </ScrollView>
          <View style={{ marginBottom: 10, backgroundColor: "#70AD47", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-evenly", }}>{/* 送信フォーム */}
            <View style={{ width: "80%", minHeight: 25, maxHeight: 90, margin: 10, }}>
              <Text style={{ opacity: 0 }}>
                {inputValue};
              </Text>
              <TextInput
                style={{ width: '100%', height: '100%', backgroundColor: "#ffffff", borderRadius: 5, paddingLeft: 10, position: 'absolute', top: 0, left: 0, }}
                value={inputValue}
                onChangeText={text => setInputValue(text)}
                multiline={true}
                placeholder="コメントを入力してください"
              />
            </View>
            <TouchableOpacity style={{ marginHorizontal: 10 }} onPress={() => sendMessage()} >
              <Image style={{ width: 30, height: 30, }} source={IconImages.icSend} />
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

/**
 * 写真拡大表示
 * @param { boolean } visible 写真の表示非表示
 * @param { stirng } imageKey 写真のS3Key
 * @param { Fucntion } onClickScreen スクリーンをクリックしたときに処理する関数
 * @returns 
 */
export const PhotoDialog = ({ visible, imageKey, onClickScreen }: { visible: boolean, imageKey: string, onClickScreen: Function; }) => {
  const [uri, setUri] = useState<string>('');

  useEffect(() => {
    (async () => {
      if (imageKey != undefined && imageKey != null) {
        const tmpUri = await Storage.get(imageKey);
        setUri(tmpUri);
      }
    })();
  }, [imageKey]);

  return (
    <Modal
      transparent={false}
      visible={visible}
    >
      <ImageZoom cropWidth={Dimensions.get('window').width}
        cropHeight={Dimensions.get('window').height}
        imageWidth={Dimensions.get('window').width}
        imageHeight={Dimensions.get('window').height}>
        <Image style={{ width: Dimensions.get('window').width, height: Dimensions.get('window').height }}
          resizeMode='contain'
          source={{ uri: uri }} />
      </ImageZoom>
      <TouchableOpacity style={{ position: "absolute", top: 20, right: 20, backgroundColor: "rgba(0,0,0,0.6)", borderRadius: 20, padding: 10 }} onPress={() => { onClickScreen() }}>
        <Image style={{ width: 20, height: 20 }}
          resizeMode='contain'
          source={IconImages.icClose} />
      </TouchableOpacity>
    </Modal>
  );
};